import { FC, useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";

import HubInputField from "src/components/inputType";
import HCPUserOptions from "./hcpUserOptions";

import useFetch from "src/hooks/useFetch";
import { getIAMDropdownOpotionsBasedOnRefType, resetDoctorAndPatientDetails } from "src/helpers/addCase";
import { AuthContext } from "src/context/authContext";

import { IOveraOnStepTwoProps } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { PatientDropdownResponse, PracticeDropdownResponse } from "src/components/caseStepTwo/types";
import ORGUserOptions from "./orgUserOptions";
import { CaseContext } from "src/context/caseContext";
import SubmittingPracticeField from "./submittingPracticeField";




const IOveraOnStepTwo: FC<IOveraOnStepTwoProps> = ({ control, getValues, setValue, trigger, watch,clearErrors }): JSX.Element => {
  const [prev_i_am] = useState(getValues("doctor_attributes.i_am"))
  const [patientListing, updatePatientListing] = useState<{ id: number, fullname: string; }[]>([])

  const { userData } = useContext(AuthContext)
  const { formControls } = useContext(CaseContext)

  const iAm = watch("doctor_attributes.i_am");
  const treatingPracticeId = watch("doctor_attributes.treating_practice_id");
  const treatingDoctorId = watch("doctor_attributes.treating_doctor_id");
  const referringPracticeId = watch("doctor_attributes.referring_practice_id");
  const referringDoctorId = watch("doctor_attributes.referring_doctor_id");
  const globalPatientId = watch("patient_attributes.global_patient_id");
  const submittingParactice = watch("doctor_attributes.submitting_practice_id")
  

  const { data: practiceDropdownApiRes } =
    useFetch<PracticeDropdownResponse>(APIEndpoints.PRACTICE_DROPDOWN, { search_query: "" }, {}, ["Practice", "Contact"].includes(userData?.ref_type || ""));



  useEffect(() => {
    const is_anesthesiologist = getValues("doctor_attributes.is_anesthesiologist")
    if (typeof is_anesthesiologist === "undefined") {
      if (userData && ["Practice", "Contact"].includes(userData.ref_type))
        setValue("doctor_attributes.is_anesthesiologist", false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(iAm && iAm !== prev_i_am) {
      if (formControls) {
        formControls.resetField("doctor_attributes.submitting_practice_id", { defaultValue: 0 })
        formControls.resetField("doctor_attributes.is_anesthesiologist", { defaultValue: false })
        formControls.resetField("doctor_attributes.treating_practice_id", { defaultValue: 0 })
        formControls.resetField("doctor_attributes.treating_doctor_id", { defaultValue: 0 })
        formControls.resetField("doctor_attributes.referring_practice_id", { defaultValue: 0 })
        formControls.resetField("doctor_attributes.referring_doctor_id", { defaultValue: 0 })
        formControls.resetField("patient_attributes.global_patient_id", { defaultValue: 0 })
        formControls.resetField("shipments_attributes", { defaultValue: [] })
      }
      resetDoctorAndPatientDetails(setValue)
    }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iAm])

// useEffect(() => {
//   console.log("changing.....", globalPatientId, submittingParactice, iAm);

//   // Step 1️⃣ - Reset both dependent booleans
//   setValue("patient_attributes.is_us_citizen", false, { shouldValidate: false });
//   setValue("patient_attributes.is_enrolled_in_federal", false, { shouldValidate: false });

//   // Step 2️⃣ - Wait a tick for dependent field (like drug_name) to stabilize
//   setTimeout(() => {
//     // Step 3️⃣ - Trigger validation manually
//     trigger([
//       "patient_attributes.is_us_citizen",
//       "patient_attributes.is_enrolled_in_federal",
//     ]);

//     // Optionally clear any leftover errors just in case
//     clearErrors && clearErrors([
//       "patient_attributes.is_us_citizen",
//       "patient_attributes.is_enrolled_in_federal",
//     ]);

//     console.log(
//       "After change:",
//       getValues("patient_attributes.is_us_citizen"),
//       getValues("patient_attributes.is_enrolled_in_federal")
//     );
//   }, 0);

//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [globalPatientId, submittingParactice, iAm]);

  // useEffect (()=>{
  //    if((iAm === "Referring and Treating Facility")){
  //      const treating_doctor = getValues('doctor_attributes.treating_doctor_id');
  //      console.log("treating_doctor",treating_doctor)
  //      setValue("doctor_attributes.referring_doctor_id",treating_doctor)
  //   }

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[iAm,treatingDoctorId])




  /**
   * @getPatientListingByDoctorId api to get patient listing from doctor id
   * @first initialize the useFetch() hook
   * @second calling patient api using selected doctor id
   * @third patient api success handler
   */
  const { error: patientListingApiError, data: patientListingApiResponse, mutate: getPatientListing } =
    useFetch<PatientDropdownResponse>(APIEndpoints.PATIENT_DROPDOWN);

  /** @second */
  useEffect(() => {
    if (userData) {
      if (["Practice", "Contact"].includes(userData.ref_type)) {
        if (practiceDropdownApiRes && patientListing.length === 0) {
          if (practiceDropdownApiRes.data && practiceDropdownApiRes.data.length > 0) {
            const patientQueryParams = {
              practice_id: practiceDropdownApiRes.data[0].id,
            };
    
            getPatientListing(null, null, patientQueryParams);
          }
        }
      }else if((["Organization"].includes(userData.ref_type)) ) {
        if (submittingParactice) {
            const patientQueryParams = {
              practice_id: submittingParactice,
            };
      
            getPatientListing(null, null, patientQueryParams);
          }
      }
      else {
        if (["Treating Facility", "Treating Provider", "Referring and Treating Facility"].includes(iAm)) {
          if (treatingPracticeId) {
            const patientQueryParams = {
              practice_id: treatingPracticeId,
            };
      
            getPatientListing(null, null, patientQueryParams);
          }
        } else {
          if (referringPracticeId) {
            const patientQueryParams = {
              practice_id: referringPracticeId,
            };
      
            getPatientListing(null, null, patientQueryParams);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceDropdownApiRes, treatingPracticeId, referringPracticeId, submittingParactice]);

  /** @third */
  useEffect(() => {
    if (patientListingApiResponse || patientListingApiError) {
      setValue("patient_attributes.global_patient_id", globalPatientId || 0);
      if (patientListingApiResponse) {
        const { data } = patientListingApiResponse
        if (["Organization"].includes(userData?.ref_type || "")) {
          updatePatientListing([...new Map(data.map(patient => [patient["id"], patient])).values()])
        } else {
          updatePatientListing((oldVal) => {
            const newPatients = [...oldVal, ...data]
              .sort((patientA, patientB) => (patientA.fullname > patientB.fullname) ? 1 : -1)
            return [...new Map(newPatients.map(patient => [patient["id"], patient])).values()];
          })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientListingApiResponse, patientListingApiError]);





  return (
    <div className="card-body">
      <div className="row">

        <div className="col-md-10">
          <Controller
            name="doctor_attributes.i_am"
            control={control}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
                <div className={"row"}>
                  <label className={"form-label col-lg-3 col-md-4 col-12"}>I am the *</label>
                  <div className={"col-lg-9 col-md-8 col-12"}>
                    <HubInputField
                        inputId="doctor_attributes.i_am"
                        // inputLabel="I am the"
                        inputPlaceholder="Select ..."
                        isRequired={true}
                        isRowBased={true}
                        field={field}
                        error={error}
                        isDropdown={true}
                        isSearchable={false}
                        dropdownData={
                          (
                              userData ? getIAMDropdownOpotionsBasedOnRefType(userData.ref_type) : []
                          ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                        }
                    />
                  </div>
                </div>
            )}
          />
        </div>
        <div className="col-md-2"></div>

        {iAm ? 
          userData && userData.ref_type === "Organization" ? (
            <>
              <SubmittingPracticeField />
              <ORGUserOptions control={control} getValues={getValues} setValue={setValue} trigger={trigger} watch={watch} />
            </>
          ) : (
            <HCPUserOptions control={control} getValues={getValues} setValue={setValue} trigger={trigger} watch={watch} />
          )
          : null
        }

        {(["Referring Facility", "Referring Provider"].includes(iAm) 
        ? (treatingDoctorId && referringDoctorId) 
        : treatingDoctorId) 
        ? (
          <>
            <div className="col-md-10">
              <Controller
                name="patient_attributes.global_patient_id"
                control={control}
                defaultValue={0}
                render={({ field, fieldState: { error } }) => (
                  <div className="row mb-2">
                    <label htmlFor="patient_attributes.global_patient_id" className="form-label col-lg-3 col-md-4 col-12 p-2">
                      Select a Patient *
                    </label>
                    <div
                      className="col-lg-9 col-md-8 col-12"
                      title={(
                        patientListing && field.value ?
                          patientListing.find((item) => item.id === field.value)?.fullname
                          : "(New Patient)"
                      )}
                      data-bs-toggle="tooltip" data-bs-placement="bottom"
                    >
                      <HubInputField
                        inputId="patient_attributes.global_patient_id"
                        inputPlaceholder="(new patient)..."
                        isRequired={true}
                        isRowBased={true}
                        field={field}
                        error={error}
                        isDropdown={true}
                        isSearchable={true}
                        dropdownData={
                          (patientListing.length > 0 ?
                            [{ value: 0, label: `(New Patient)` }, ...patientListing.map((patient) => ({ value: patient.id, label: patient.fullname }))]
                            : [{ value: 0, label: `(New Patient)` }]
                          ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                        }
                      />
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col-md-2"></div>
          </>
        ) : null}

      </div>
    </div>
  )
}

export default IOveraOnStepTwo
